import { Routes } from '@angular/router';
import { ModifiersComponent } from 'ng2-app/components/modifiers/modifiers.component';
import { ApiRedirectGuard } from './routes/guards/api-redirect.guard';
import { AuthGuard } from './routes/guards/auth.guard';
import { hasPermissionGuard } from './routes/guards/has-permission.guard';
import { LoginGuard } from './routes/guards/login.guard';

export const routes: Routes = [
  {
    path: 'modifiers',
    component: ModifiersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'borrower',
    loadChildren: () => import('./borrower/borrower-page-routing.module').then(m => m.BorrowerPageRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'today',
    loadChildren: () => import('./modules/today/today-routing.module').then(m => m.TodayRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'funnel',
    loadChildren: () => import('./modules/funnel/funnel-routing.module').then(m => m.FunnelRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'deals',
    loadChildren: () => import('./modules/team-deals/team-deals-routing.module').then(m => m.TeamDealsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'list',
    loadChildren: () => import('./borrower-index/borrower-index-routing.module').then(m => m.BorrowerIndexRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'priority',
    loadChildren: () => import('./priority/priority-routing.module').then(m => m.PriorityRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./routes/login/login-routing.module').then(m => m.LoginRoutingModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'nova',
    canActivate: [ApiRedirectGuard],
    children: [
      {
        path: '**',
        loadComponent: () => import('./page-not-found/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
      }
    ]
  },
  {
    path: 'performance',
    loadChildren: () => import('./performance/performance-routing.module').then(m => m.PerformanceRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pulse',
    loadChildren: () => import('./pulse/pulse-routing.module').then(m => m.PulseRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sales-inventory',
    loadChildren: () => import('./sales-inventory/sales-inventory-routing.module').then(m => m.SalesInventoryRoutingModule),
    canActivate: [AuthGuard, hasPermissionGuard],
    data: {
      permission: 'salesInventoryTracker.read',
    },
  },
  {
    path: 'workflows',
    loadChildren: () => import('./workflows/workflows-routing.module').then(m => m.WorkflowsRoutingModule),
    canActivate: [AuthGuard, hasPermissionGuard],
    data: {
      permission: 'workflow.read',
    },
  },
  {
    path: 'cx-performance',
    loadChildren: () => import('./performance-cx/cx-performance-routing.module').then(m => m.CXPerformanceRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ring-draw-deals',
    loadChildren: () => import('./admin/ring-draw-deals/ring-draw-deals-routing.module').then(m => m.RingDrawDealsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'rollbar',
    loadComponent: () => import('./rollbar-test/rollbar-test/rollbar-test.component').then(m => m.RollbarTestComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'schedule',
    loadChildren: () => import('./schedule-reminder/schedule-reminder-routing.module').then(m => m.ScheduleReminderRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./user-settings/user-settings-routing.module').then(m => m.UserSettingsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sender-view-redirect',
    loadComponent: () => import('./docusign/sender-view-redirect.component').then(m => m.SenderViewRedirectComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'token',
    loadComponent: () => import('./routes/token/token.component').then(m => m.TokenComponent)
  },
  {
    path: 'auth-error',
    loadComponent: () => import('./auth-error/auth-error.component').then(m => m.AuthErrorComponent)
  },
  {
    path: '',
    loadChildren: () => import('./modules/task-management/task-management-routing.module').then(m => m.TaskManagementRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    loadComponent: () => import('./page-not-found/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
    canActivate: [AuthGuard]
  },
];
